var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "w-100 my-2",
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('b-container', {
    staticClass: "align-content-start d-flex p-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._t("body-items")], 2)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }